import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';
import moment from 'moment';
import { exportToExcel } from '../../../../../../utils/exportToExcel';
import XLSX from 'xlsx';
import {
  defaultJournalEntryImportDateDisplay,
  JOURNAL_ENTRY_FECHA_COLUMN,
  parseJournalEntriesSheet,
} from './journalEntryExcelParser';
import './JournalEntryImportExport.scss';

const JournalEntryImportExport = ({ onImport, accounts = [] }) => {
  const { t } = useTranslation('configuracion');
  const fileInputRef = useRef(null);

  const handleDownloadTemplate = () => {
    const defaultDate = defaultJournalEntryImportDateDisplay();
    const midMonthDate = moment().startOf('month').date(15).format('DD/MM/YYYY');
    const templateData = [
      {
        [JOURNAL_ENTRY_FECHA_COLUMN]: defaultDate,
        Código: '1.02.01.01',
        'Nombre (opcional)': 'Banco',
        Debe: '1000000',
        Haber: '0',
        'RUT (opcional)': '',
        'Razon social (opcional)': '',
        'Glosa (opcional)': 'Ejemplo asiento 1',
      },
      {
        [JOURNAL_ENTRY_FECHA_COLUMN]: '',
        Código: '4.01.01.01',
        'Nombre (opcional)': 'Ingresos',
        Debe: '0',
        Haber: '1000000',
        'RUT (opcional)': '',
        'Razon social (opcional)': '',
        'Glosa (opcional)': '',
      },
      {
        [JOURNAL_ENTRY_FECHA_COLUMN]: midMonthDate,
        Código: '1.02.01.01',
        'Nombre (opcional)': 'Banco',
        Debe: '500000',
        Haber: '0',
        'RUT (opcional)': '',
        'Razon social (opcional)': '',
        'Glosa (opcional)': 'Ejemplo asiento 2',
      },
      {
        [JOURNAL_ENTRY_FECHA_COLUMN]: '',
        Código: '3.01.01.01',
        'Nombre (opcional)': 'Gasto',
        Debe: '0',
        Haber: '500000',
        'RUT (opcional)': '',
        'Razon social (opcional)': '',
        'Glosa (opcional)': '',
      },
    ];

    const columns = [
      { key: JOURNAL_ENTRY_FECHA_COLUMN, label: JOURNAL_ENTRY_FECHA_COLUMN },
      { key: 'Código', label: 'Código' },
      { key: 'Nombre (opcional)', label: 'Nombre (opcional)' },
      { key: 'Debe', label: 'Debe' },
      { key: 'Haber', label: 'Haber' },
      { key: 'RUT (opcional)', label: 'RUT (opcional)' },
      { key: 'Razon social (opcional)', label: 'Razon social (opcional)' },
      { key: 'Glosa (opcional)', label: 'Glosa (opcional)' },
    ];

    const fileName = `plantilla-asiento-contable-${new Date().toISOString().split('T')[0]}.xlsx`;

    exportToExcel({
      rows: templateData,
      columns,
      fileName,
      sheetName: 'Asientos Contables',
    });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array', cellText: true, cellNF: true });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const { drafts, error, missingAccountKeys } = parseJournalEntriesSheet(
          sheet,
          accounts,
        );

        if (error) {
          alert(error);
          return;
        }

        if (onImport) onImport({ drafts, missingAccountKeys });

        if (fileInputRef.current) fileInputRef.current.value = '';
      } catch (err) {
        console.error('Error reading Excel file:', err);
        alert('Error al leer el archivo Excel. Por favor, verifica que el formato sea correcto.');
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="tw-w-full tw-bg-gray-50 tw-rounded-lg tw-p-6 tw-mb-4 tw-shadow-sm">
      <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-flex-wrap">
        <p className="tw-m-0 tw-text-sm tw-text-gray-600 tw-leading-relaxed tw-flex-1 tw-min-w-[200px]">
          {t('journalEntryModal.importHint')}{' '}
          <button
            type="button"
            className="tw-bg-transparent tw-border-none tw-text-[#488E9D] tw-underline tw-cursor-pointer tw-text-sm tw-p-0 tw-font-semibold hover:tw-text-[#3a7280] focus:tw-outline-none tw-transition-colors"
            onClick={handleDownloadTemplate}
          >
            {t('journalEntryModal.download')}
          </button>
        </p>
        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileUpload}
          style={{ display: 'none' }}
        />
        <Button
          type="button"
          size="small"
          onClick={handleUploadClick}
          className="journal-entry-import-export-button tw-flex-shrink-0"
        >
          {t('journalEntryModal.upload')}
          <i className="arrow up right icon" style={{ marginLeft: '0.5em' }}></i>
        </Button>
      </div>
    </div>
  );
};

export default JournalEntryImportExport;
